import React from 'react';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  initials: string;
  name: string;
  location: string;
  quote: string;
}
interface TestimonialRowProps {
  testimonials: Testimonial[];
  title?: string;
}
export function TestimonialRow({
  testimonials,
  title
}: TestimonialRowProps) {
  return <section className="py-16 px-4 sm:px-6 lg:px-8" data-id="element-189">
      <div className="max-w-6xl mx-auto" data-id="element-190">
        {title && <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12 text-[#1A1A1A]" data-id="element-191">
            {title}
          </h2>}
        <div className="grid md:grid-cols-3 gap-6" data-id="element-192">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white border border-[#EAE5DC] shadow-sm rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-193">
              <div className="flex items-center gap-1 mb-4" data-id="element-194">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-[#F0C040] text-[#F0C040]" data-id="element-195" />)}
              </div>
              <p className="text-[#1A1A1A] mb-4 leading-relaxed font-medium" data-id="element-196">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-197">
                <div className="w-10 h-10 rounded-full bg-[#6B9BD1] flex items-center justify-center" data-id="element-198">
                  <span className="text-sm font-bold text-white" data-id="element-199">
                    {testimonial.initials}
                  </span>
                </div>
                <div data-id="element-200">
                  <div className="font-semibold text-sm text-[#1A1A1A]" data-id="element-201">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-[#6B7280]" data-id="element-202">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}